import { AssistantItems, Traceable } from '@repo/shared/dtos/assistant'
import { cn } from '@repo/ui/utils'
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js'
import { ReactNode } from 'react'
import { Bar, Line, Pie } from 'react-chartjs-2'

import { MarkdownWrapper } from '@/components/MarkdownWrapper'
import { useTrace } from '@/hooks'

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
)

export function BotMessage({
  className,
  children,
  traceUrl,
}: {
  children: ReactNode | string
  className?: string
} & Traceable) {
  const { Trace } = useTrace({ traceUrl })
  const isString = typeof children === 'string'
  const hasHtmlOrMarkdown =
    isString && (/<\/?[a-z][\s\S]*>/i.test(children) || /[#_*~`]/.test(children))
  return (
    <div className="flex flex-col gap-1">
      <div
        className={cn(
          'bg-white border-primary-50 border max-w-3/4 flex flex-col h-fit w-fit items-start gap-2 whitespace-pre-wrap rounded-xl rounded-tl-none py-2.5 px-4 text-base text-primary-700 shadow-lg',
          !hasHtmlOrMarkdown && 'whitespace-pre-wrap text-pretty',
          className,
        )}
      >
        {hasHtmlOrMarkdown ? <MarkdownWrapper theme="dark" content={children} /> : children}
      </div>

      <div className="ml-5">
        <Trace />
      </div>
    </div>
  )
}

const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
  },
}
export function BotChart({
  chart,
}: {
  chart: AssistantItems['chart']
} & Traceable) {
  const ChartComponent = {
    pie: Pie,
    line: Line,
    bar: Bar,
  }[chart.data.type]
  const { Trace } = useTrace({ traceUrl: chart.traceUrl })
  return (
    <div className="flex flex-col gap-1">
      <div className="mb-2 max-h-[50vh]">
        <ChartComponent data={chart.data.payload} options={chartOptions} />
      </div>
      <div className="ml-5">
        <Trace />
      </div>
    </div>
  )
}
